var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable array-bracket-spacing, comma-dangle, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var NumberInput = require("../components/number-input.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var InfoTip = require("../components/info-tip.jsx");

var MAX_SIZE = 8;

// styling
var CELL_PADDING = 5;

var TABLE_STYLE = {
    display: "table",
    tableLayout: "fixed"
};

var ROW_STYLE = {
    display: "table-row"
};

var CELL_STYLE = {
    display: "table-cell",
    padding: CELL_PADDING
};

var BASE_TILE_STYLE = {
    borderRadius: 10,
    cursor: "pointer"
};

var PATTERNS = {
    plus: function plus() {
        return [[false, true, false], [true, true, true], [false, true, false]];
    },
    x: function x() {
        return [[true, false, true], [false, true, false], [true, false, true]];
    },
    "plus/x": function plusX(iter) {
        return iter % 2 ? PATTERNS.x() : PATTERNS.plus();
    }
};

/**
 * Clamps value to an integer in the range [min, max]
 */
var clampToInt = function clampToInt(value, min, max) {
    value = Math.floor(value);
    value = Math.max(value, min);
    value = Math.min(value, max);
    return value;
};

// Returns a copy of the tiles, with tiles flipped according to
// whether or not their y, x position satisfies the predicate
var flipTilesPredicate = function flipTilesPredicate(oldCells, predicate) {
    return _.map(oldCells, function (row, y) {
        return _.map(row, function (cell, x) {
            return predicate(y, x) ? !cell : cell;
        });
    });
};

// A single glowy cell
var Tile = React.createClass({
    displayName: "Tile",

    propTypes: {
        value: React.PropTypes.bool.isRequired,
        size: React.PropTypes.number.isRequired
    },

    render: function render() {
        var color = this.props.value ? "#55dd55" : "#115511";
        var style = _.extend({}, BASE_TILE_STYLE, {
            width: this.props.size,
            height: this.props.size,
            backgroundColor: color
        });
        return React.createElement("div", { style: style, onClick: this._flip });
    },

    _flip: function _flip() {
        this.props.onChange(!this.props.value);
    }
});

// A grid of glowy cells
var TileGrid = React.createClass({
    displayName: "TileGrid",

    propTypes: {
        cells: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.bool)).isRequired,
        size: React.PropTypes.number.isRequired
    },

    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { style: TABLE_STYLE, className: "no-select" },
            _.map(this.props.cells, function (row, y) {
                return React.createElement(
                    "div",
                    { key: y, style: ROW_STYLE },
                    _.map(row, function (cell, x) {
                        return React.createElement(
                            "div",
                            { key: x, style: CELL_STYLE },
                            React.createElement(Tile, {
                                value: cell,
                                size: _this.props.size,
                                onChange: _.partial(_this.props.onChange, y, x)
                            })
                        );
                    })
                );
            })
        );
    }
});

// The widget editor
var LightsPuzzleEditor = React.createClass({
    displayName: "LightsPuzzleEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        startCells: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.bool)),
        flipPattern: React.PropTypes.string.isRequired,
        gradeIncompleteAsWrong: React.PropTypes.bool.isRequired
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            startCells: [[false, false, false], [false, false, false], [false, false, false]],
            flipPattern: "plus",
            gradeIncompleteAsWrong: false
        };
    },

    _height: function _height() {
        return this.props.startCells.length;
    },

    _width: function _width() {
        if (this.props.startCells.length !== 0) {
            return this.props.startCells[0].length;
        } else {
            return 0; // default to 0
        }
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                "Width:",
                React.createElement(NumberInput, {
                    value: this._width(),
                    placeholder: 5,
                    onChange: this._changeWidth
                }),
                ", ",
                "Height:",
                React.createElement(NumberInput, {
                    value: this._height(),
                    placeholder: 5,
                    onChange: this._changeHeight
                })
            ),
            React.createElement(
                "div",
                null,
                "Flip pattern:",
                React.createElement(
                    "select",
                    {
                        value: this.props.flipPattern,
                        onChange: this._handlePatternChange
                    },
                    _.map(_.keys(PATTERNS), function (pattern, i) {
                        return React.createElement(
                            "option",
                            { value: pattern, key: i },
                            pattern
                        );
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                "Grade incomplete puzzles as wrong:",
                " ",
                React.createElement(PropCheckBox, {
                    gradeIncompleteAsWrong: this.props.gradeIncompleteAsWrong,
                    onChange: this.props.onChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    "By default, incomplete puzzles are graded as empty."
                )
            ),
            React.createElement(
                "div",
                null,
                "Starting configuration:"
            ),
            React.createElement(
                "div",
                { style: { overflowX: "auto" } },
                React.createElement(TileGrid, {
                    cells: this.props.startCells,
                    size: 50,
                    onChange: this._switchTile
                })
            )
        );
    },

    _handlePatternChange: function _handlePatternChange(e) {
        this.change("flipPattern", e.target.value);
    },

    _changeWidth: function _changeWidth(newWidth) {
        newWidth = clampToInt(newWidth, 1, MAX_SIZE);
        this._truncateCells(newWidth, this._height());
    },

    _changeHeight: function _changeHeight(newHeight) {
        newHeight = clampToInt(newHeight, 1, MAX_SIZE);
        this._truncateCells(this._width(), newHeight);
    },

    _truncateCells: function _truncateCells(newWidth, newHeight) {
        var _this2 = this;

        var newCells = _.times(newHeight, function (y) {
            return _.times(newWidth, function (x) {
                // explicitly cast the result to a boolean with !!
                return !!(_this2.props.startCells[y] && _this2.props.startCells[y][x]);
            });
        });

        this.change({ startCells: newCells });
    },

    _switchTile: function _switchTile(tileY, tileX) {
        var newCells = flipTilesPredicate(this.props.startCells, function (y, x) {
            return y === tileY && x === tileX;
        });

        this.change({ startCells: newCells });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = LightsPuzzleEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/lights-puzzle-editor.jsx
 ** module id = 121
 ** module chunks = 0 1
 **/